/** PDN ciphertext from core looks like `v1:v1:<nonce>:<payload>`. Never render it in UI. */
export const isPdnCiphertext = (value: string | null | undefined): boolean => {
  if (!value) {
    return false
  }
  const trimmed = value.trim()
  return trimmed.startsWith('v1:') || trimmed.startsWith('v1:v1:')
}

export const safeDisplayText = (
  value: string | null | undefined,
  fallback: string,
): string => {
  const trimmed = value?.trim() ?? ''
  if (!trimmed || isPdnCiphertext(trimmed)) {
    return fallback
  }
  return trimmed
}
